import { useCallback, useSyncExternalStore } from 'react';
import { getSavedUi, saveUi } from '../utils/filterUtils';

/**
 * Pure UI preference — kept out of the URL (nothing to share) and out of Redux
 * (nothing to coordinate). A tiny external store so the navbar toggle and the
 * dashboard stay in sync.
 */
let showCharts = getSavedUi()?.showCharts ?? true;
const listeners = new Set();

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => showCharts;

export const useShowCharts = () => {
  const value = useSyncExternalStore(subscribe, getSnapshot);

  const setValue = useCallback((next) => {
    showCharts = next;
    saveUi({ ...(getSavedUi() || {}), showCharts: next });
    listeners.forEach((listener) => listener());
  }, []);

  return [value, setValue];
};
